import {
  useGetQBankStructureLevelItemsForQuestionCreationQuery,
  useGetQBankStructureLevelsForQuestionCreationQuery,
} from '@exam-management/graphql';
import { formatQBankStructureLevelItems } from '@exam-management/qbs-provider';
import { useMemo } from 'react';

export default function useGetQBSLevelAndLevelItemsForTask(
  qBankStructureId: string,
  taskId: string,
) {
  const { data: getQBSLevelResult, loading: isGettingQBSLevel } =
    useGetQBankStructureLevelsForQuestionCreationQuery({
      variables: {
        qBankStructureId,
        taskId,
      },
    });

  const { data: getQBSLevelItemResult, loading: isGettingQBSLevelItems } =
    useGetQBankStructureLevelItemsForQuestionCreationQuery({
      variables: {
        qBankStructureId,
        taskId,
      },
    });

  const qBankStructureLevels = useMemo(
    () => getQBSLevelResult?.qbsGetTaskQBankStructureLevelsByQBankStructureId ?? [],
    [getQBSLevelResult],
  );

  const qBankStructureLevelWithoutFirstLevel = useMemo(
    () =>
      qBankStructureLevels
        .filter((qBankStructureLevel) => qBankStructureLevel.level !== 1)
        .sort((a, b) => a.level - b.level),
    [qBankStructureLevels],
  );

  const qbsLevelItems = useMemo(
    () => getQBSLevelItemResult?.qbsGetTaskQBankStructureLevelItemsByQBankStructureId ?? [],
    [getQBSLevelItemResult],
  );

  const qbsLevelItemsWithLevel = useMemo(
    () => formatQBankStructureLevelItems(qbsLevelItems, qBankStructureLevels),
    [qbsLevelItems, qBankStructureLevels],
  );

  return {
    qbsLevels: qBankStructureLevelWithoutFirstLevel,
    qbsLevelItems: qbsLevelItemsWithLevel,
    loading: isGettingQBSLevel || isGettingQBSLevelItems,
  };
}
